import { Stack, styled, Typography, Theme } from '@mui/material';
import { isBrowser } from 'react-device-detect';

import CabinetBgLogoIcon from '../../assets/icons/cabinetBgLogoIcon.svg?react';
import ServiceUnavailableIcon from '../../assets/icons/serviceUnavailable.svg?react';
import { useTranslation } from 'react-i18next';

const StyledMain = styled('main')(() => ({
  flex: '1 1 auto',
  backgroundColor: '#353434',
}));

export const UnavailableServicePage = () => {
  const { t } = useTranslation();
  return (
    <StyledMain>
      <Stack
        sx={(theme: Theme) => ({
          position: 'relative',
          maxWidth: !isBrowser ? '100%' : '400px',
          width: '100%',
          backgroundColor: theme.palette.gray[300],
          alignItems: 'center',
          overflow: 'hidden',
        })}
      >
        <CabinetBgLogoIcon
          width="100%"
          style={{
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 1,
          }}
        />
        <Stack
          justifyContent="center"
          alignItems="center"
          sx={{ zIndex: 2, height: '100%', width: '100%', gap: '50px' }}
        >
          <ServiceUnavailableIcon />
          <Stack alignItems="center" sx={{ gap: '15px' }}>
            <Typography color="green.main" sx={{ fontSize: '40px' }}>
              502
            </Typography>
            <Typography color="common.white" variant="body1" textAlign="center">
              {t('serviceUnavailablePage.firstLineText')} <br />{' '}
              {t('serviceUnavailablePage.secondLineText')}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </StyledMain>
  );
};
